import { useState, useEffect } from 'react';

export default function useResponsive() {
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return {
    isMobile: width < 768,
    isTablet: width >= 768 && width < 1024,
    isDesktop: width >= 1024,
    isSmallMobile: width < 480,
    isLargeDesktop: width >= 2400,
    isLandscape:
      typeof window !== "undefined" && window.innerHeight > 0
        ? window.innerWidth > window.innerHeight
        : true,
    width,
  };
}
